import { TyloHomeAssortmentComponent } from './components/tylo-home-assortment/tylo-home-assortment.component';
import localeEn from '@angular/common/locales/en';
import localeSv from '@angular/common/locales/sv';
import localeFi from '@angular/common/locales/fi';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { GungDashboardComponent } from 'gung-dashboard';
import {
  AuthGuard,
  CustomPageResolverService,
  CustomPageDisplayComponent,
  AdminGuard,
  LanguageConfigService
} from 'gung-standard';
import { LoginWrapperComponent } from 'gung-standard';
import { TyloProductDetailComponent } from './components/tylo-product-detail/tylo-product-detail.component';
import { registerLocaleData } from '@angular/common';
import { TyloProductListComponent } from './components/tylo-product-list/tylo-product-list.component';
import { TyloDeliveryPlanningComponent } from './components/tylo-delivery-planning/tylo-delivery-planning.component';
import { TyloDocumentsListComponent } from './components/tylo-documents-list/tylo-documents-list.component';
import { environment } from './../environments/environment';
import { TyloLoginWrapperComponent } from './components/tylo-login-wrapper/tylo-login-wrapper.component';
import { TyloDocumentsComponent } from './components/documents-upload/tylo-documents/tylo-documents.component';
import { TyloHomeComponent } from './components/tylo-home/tylo-home.component';
import { HeloWarrantyFormComponent } from './components/helo-warranty-form/helo-warranty-form.component';
import { Title } from '@angular/platform-browser';
import { TyloOrderDetailsComponent } from './components/tylo-order-details/tylo-order-details.component';
import { TyloDigitalAssetsWrapperComponent } from './components/digital-assets/tylo-digital-assets-wrapper/tylo-digital-assets-wrapper.component';
import { HeloSaunaVolumeCalculatorComponent } from './components/helo-sauna-volume-calculator/helo-sauna-volume-calculator.component';

@Component({
  selector: 'tylo-root',
  template: `<tylo-app-wrapper></tylo-app-wrapper>`
})
export class TyloAppComponent {
  favIcon: HTMLLinkElement = document.querySelector('#appIcon');

  constructor(
    private router: Router,
    translate: TranslateService,
    private titleService: Title,
    private languageConfigService: LanguageConfigService
  ) {
    const lang = localStorage.getItem('selectedLanguage');
    const defaultLang = this.languageConfigService.getDefaultLanguage();
    translate.use(lang || defaultLang);
    registerLocaleData(localeEn);
    registerLocaleData(localeSv);
    registerLocaleData(localeFi);
    this.setupRoutes();

    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      localStorage.setItem('selectedLanguage', event.lang);
    });
  }

  private setupRoutes() {
    const config = this.router.config;

    this.router.resetConfig([
      {
        path: '',
        canActivate: [AuthGuard],
        component: TyloHomeComponent
      },
      {
        path: 'product/:productId',
        canActivate: [AuthGuard],
        component: TyloProductDetailComponent
      },
      {
        path: 'forgot-password',
        component: TyloLoginWrapperComponent,
        data: {
          login: 'FashionLogin'
        }
      },
      {
        path: 'login',
        component: TyloLoginWrapperComponent,
        data: {
          login: 'FashionLogin'
        }
      },
      {
        path: 'categories2',
        component: CustomPageDisplayComponent,
        resolve: {
          pageComponent: CustomPageResolverService
        },
        data: {
          pageName: 'home'
          // pageComponent: HomeDefaultTemplateComponent
        },
        canActivate: [AuthGuard]
      },
      {
        path: 'categories',
        component: TyloHomeAssortmentComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'categories/:assortmentId',
        canActivate: [AuthGuard],
        component: TyloProductListComponent
      },
      {
        path: 'delivery-planning',
        component: TyloDeliveryPlanningComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'view-documents',
        component: TyloDocumentsListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'admin/documents',
        component: TyloDocumentsComponent,
        canActivate: [AuthGuard, AdminGuard]
      },
      {
        path: 'warranty-form',
        component: HeloWarrantyFormComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'orders/:orderId',
        canActivate: [AuthGuard],
        component: TyloOrderDetailsComponent
      },
      {
        path: 'digital-assets/management',
        canActivate: [AuthGuard, AdminGuard],
        children: [
          {
            path: '**',
            component: TyloDigitalAssetsWrapperComponent
          }
        ]
      },
      {
        path: 'sauna-volume-calculator',
        canActivate: [AuthGuard],
        component: HeloSaunaVolumeCalculatorComponent
      },
      ...config
    ]);
  }
}
